import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideInvestmentPlan, InvestmentPlanFormData } from './types'
import { AiInstructionFormData } from '../common/types'

export const useInvestmentPlanRegenerate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isRegenerating, setIsRegenerating] = useState(false)

  const regenerateInvestmentPlan = async (
    id: string,
    aiInstruction: string,
    setInvestmentPlan: (investmentPlan: SlideInvestmentPlan) => void,
    resetAiForm: (data: AiInstructionFormData) => void,
    resetForm: (data: InvestmentPlanFormData) => void
  ) => {
    if (!aiInstruction.trim() || !id) return

    setIsRegenerating(true)

    try {
      const response = await apiClient.business.slideInvestmentRegenerateCreate({
        businessIdeaId: id,
        aiInstruction: aiInstruction,
      })

      if (response.data?.investmentPlan) {
        setInvestmentPlan(response.data.investmentPlan)
        resetAiForm({ aiInstruction: '' })
        showSnackBar(['収益モデルと投資計画のAI再生成が完了しました'], 'success', null) // 自動で消えない

        try {
          resetForm({
            profitStructure: response.data.investmentPlan.profitStructure,
            profitStructureItems: JSON.parse(response.data.investmentPlan.profitStructureItems || '[]'),
            cashFlow: response.data.investmentPlan.cashFlow,
            cashFlowItems: JSON.parse(response.data.investmentPlan.cashFlowItems || '[]'),
            financialPlan: response.data.investmentPlan.financialPlan,
            financialPlanItems: JSON.parse(response.data.investmentPlan.financialPlanItems || '[]'),
          })
        } catch (parseError) {
          console.error('JSONパースエラー:', parseError)
          showSnackBar(['収益モデルと投資計画のデータの読み込みに失敗しました。'], 'error', null) // 自動で消えない
        }
      }
    } catch (e) {
      console.error('収益モデルと投資計画のAI再生成に失敗しました:', e)
      handleError(e as ApiErrorResponse, (messages, severity) => {
        showSnackBar(messages, severity, null) // 自動で消えない
      })
    } finally {
      setIsRegenerating(false)
    }
  }

  return {
    isRegenerating,
    regenerateInvestmentPlan,
  }
}
